// tslint:disable
/**
 * TC API
 * TestCollab is a test management tool that helps development teams carry out testing effectively and avoid failures. # Introduction This is an API documentation for TestCollab 2.   # Authentication TestCollab supports two forms of authentication:   - An <b>API token</b> is required to make API calls. The token can be generated from user's profile; to obtain it login to your TestCollab account and go to ['My Profile Settings'](https://testcollab.io/my_profile) and switch to API Token tab. Click on \"Generate new API token\", Once the token is generated it can be sent as a query parameter for the API calls made - https://api.testcollab.io/projects?token=<generated-API-token>    - <b>Bearer authentication</b> (also called token authentication) is an HTTP authentication scheme that involves security tokens called bearer tokens. You can generate bearer auth token using [Login](#operation/login) API.     Send this token as the Authorization header while making requests to protected resources:     `Authorization: Bearer <token>`    For making API calls, we recommend using the <b>API token</b> generated from user profile page as it won't affect the on-going user session and will be available until it is revoked by the user who generated it.      # Error Handling Error responses   - `Not Found` - Error is sent when requested resource is not available.   - `Unauthorized - invalid token` - Error is sent when API token sent with the request is invalid or revoked. Error contains status code 401        - `Forbidden` - Error is sent when logged in user is not part of the company, project or his role does not allow to complete given action. Response consist of 403 status code and more information is given in error message.
 *
 * OpenAPI spec version: 2.3.1
 * Contact: support@testcollab.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from "../runtime";
import {
  Build,
  BuildFromJSON,
  BuildToJSON,
  BuildMinified,
  BuildMinifiedFromJSON,
  BuildMinifiedToJSON,
  BuildPayload,
  BuildPayloadFromJSON,
  BuildPayloadToJSON,
  BuildTraceability,
  BuildTraceabilityFromJSON,
  BuildTraceabilityToJSON,
  Count,
  CountFromJSON,
  CountToJSON,
  DefaultResponseError,
  DefaultResponseErrorFromJSON,
  DefaultResponseErrorToJSON,
  ForbiddenError,
  ForbiddenErrorFromJSON,
  ForbiddenErrorToJSON,
} from "../models";

export interface AddBuildRequest {
  buildPayload?: BuildPayload;
}

export interface CountBuildsRequest {
  project: number;
  environment?: string;
  filter?: string;
}

export interface DeleteBuildRequest {
  id: number;
  project: number;
}

export interface EditBuildRequest {
  id: number;
  buildPayload?: BuildPayload;
}

export interface GetBuildRequest {
  id: number;
}

export interface GetBuildTraceabilityRequest {
  id: number;
  project: number;
}

export interface GetBuildsRequest {
  project: number;
  environment?: string;
  versionContains?: string;
  limit?: number;
  start?: number;
  sort?: string;
  filter?: string;
}

/**
 * no description
 */
export class BuildsApi extends runtime.BaseAPI {
  /**
   * Creates a new build
   * Create a build
   */
  async addBuildRaw(
    requestParameters: AddBuildRequest
  ): Promise<runtime.ApiResponse<BuildMinified>> {
    const queryParameters: runtime.HTTPQuery = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] =
        this.configuration.apiKey("Authorization"); // bearerAuth authentication
    }

    const response = await this.request({
      path: `/builds`,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: BuildPayloadToJSON(requestParameters.buildPayload),
    });

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      BuildMinifiedFromJSON(jsonValue)
    );
  }

  /**
   * Creates a new build
   * Create a build
   */
  async addBuild(requestParameters: AddBuildRequest): Promise<BuildMinified> {
    const response = await this.addBuildRaw(requestParameters);
    return await response.value();
  }

  /**
   * Get count of builds for a specific project
   * Count builds
   */
  async countBuildsRaw(
    requestParameters: CountBuildsRequest
  ): Promise<runtime.ApiResponse<Count>> {
    if (
      requestParameters.project === null ||
      requestParameters.project === undefined
    ) {
      throw new runtime.RequiredError(
        "project",
        "Required parameter requestParameters.project was null or undefined when calling countBuilds."
      );
    }

    const queryParameters: runtime.HTTPQuery = {};

    if (requestParameters.project !== undefined) {
      queryParameters["project"] = requestParameters.project;
    }

    if (requestParameters.environment !== undefined) {
      queryParameters["environment"] = requestParameters.environment;
    }

    if (requestParameters.filter !== undefined) {
      queryParameters["_filter"] = requestParameters.filter;
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] =
        this.configuration.apiKey("Authorization"); // bearerAuth authentication
    }

    const response = await this.request({
      path: `/builds/count`,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    });

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      CountFromJSON(jsonValue)
    );
  }

  /**
   * Get count of builds for a specific project
   * Count builds
   */
  async countBuilds(requestParameters: CountBuildsRequest): Promise<Count> {
    const response = await this.countBuildsRaw(requestParameters);
    return await response.value();
  }

  /**
   * Deletes a specific build.
   * Delete a build
   */
  async deleteBuildRaw(
    requestParameters: DeleteBuildRequest
  ): Promise<runtime.ApiResponse<any>> {
    if (requestParameters.id === null || requestParameters.id === undefined) {
      throw new runtime.RequiredError(
        "id",
        "Required parameter requestParameters.id was null or undefined when calling deleteBuild."
      );
    }

    if (
      requestParameters.project === null ||
      requestParameters.project === undefined
    ) {
      throw new runtime.RequiredError(
        "project",
        "Required parameter requestParameters.project was null or undefined when calling deleteBuild."
      );
    }

    const queryParameters: runtime.HTTPQuery = {};

    if (requestParameters.project !== undefined) {
      queryParameters["project"] = requestParameters.project;
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] =
        this.configuration.apiKey("Authorization"); // bearerAuth authentication
    }

    const response = await this.request({
      path: `/builds/{id}`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(requestParameters.id))
      ),
      method: "DELETE",
      headers: headerParameters,
      query: queryParameters,
    });

    return new runtime.TextApiResponse(response);
  }

  /**
   * Deletes a specific build.
   * Delete a build
   */
  async deleteBuild(requestParameters: DeleteBuildRequest): Promise<any> {
    const response = await this.deleteBuildRaw(requestParameters);
    return await response.value();
  }

  /**
   * Edits a specific build
   * Edit a build
   */
  async editBuildRaw(
    requestParameters: EditBuildRequest
  ): Promise<runtime.ApiResponse<BuildMinified>> {
    if (requestParameters.id === null || requestParameters.id === undefined) {
      throw new runtime.RequiredError(
        "id",
        "Required parameter requestParameters.id was null or undefined when calling editBuild."
      );
    }

    const queryParameters: runtime.HTTPQuery = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] =
        this.configuration.apiKey("Authorization"); // bearerAuth authentication
    }

    const response = await this.request({
      path: `/builds/{id}`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(requestParameters.id))
      ),
      method: "PUT",
      headers: headerParameters,
      query: queryParameters,
      body: BuildPayloadToJSON(requestParameters.buildPayload),
    });

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      BuildMinifiedFromJSON(jsonValue)
    );
  }

  /**
   * Edits a specific build
   * Edit a build
   */
  async editBuild(requestParameters: EditBuildRequest): Promise<BuildMinified> {
    const response = await this.editBuildRaw(requestParameters);
    return await response.value();
  }

  /**
   * Get details of a specific build
   * Get build
   */
  async getBuildRaw(
    requestParameters: GetBuildRequest
  ): Promise<runtime.ApiResponse<Build>> {
    if (requestParameters.id === null || requestParameters.id === undefined) {
      throw new runtime.RequiredError(
        "id",
        "Required parameter requestParameters.id was null or undefined when calling getBuild."
      );
    }

    const queryParameters: runtime.HTTPQuery = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] =
        this.configuration.apiKey("Authorization"); // bearerAuth authentication
    }

    const response = await this.request({
      path: `/builds/{id}`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(requestParameters.id))
      ),
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    });

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      BuildFromJSON(jsonValue)
    );
  }

  /**
   * Get details of a specific build
   * Get build
   */
  async getBuild(requestParameters: GetBuildRequest): Promise<Build> {
    const response = await this.getBuildRaw(requestParameters);
    return await response.value();
  }

  /**
   * Aggregated traceability for a build (TCV-6726): execution results summed across every test plan linked to the build, per-plan result distribution, build-scoped risk coverage (risks exercised by test cases executed against the build), and the defects raised against those plans. Powers the Build detail traceability view. The response is provider-neutral — the client chooses the manual vs. Azure DevOps presentation from project settings.
   * Build traceability
   */
  async getBuildTraceabilityRaw(
    requestParameters: GetBuildTraceabilityRequest
  ): Promise<runtime.ApiResponse<BuildTraceability>> {
    if (requestParameters.id === null || requestParameters.id === undefined) {
      throw new runtime.RequiredError(
        "id",
        "Required parameter requestParameters.id was null or undefined when calling getBuildTraceability."
      );
    }

    if (
      requestParameters.project === null ||
      requestParameters.project === undefined
    ) {
      throw new runtime.RequiredError(
        "project",
        "Required parameter requestParameters.project was null or undefined when calling getBuildTraceability."
      );
    }

    const queryParameters: runtime.HTTPQuery = {};

    if (requestParameters.project !== undefined) {
      queryParameters["project"] = requestParameters.project;
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] =
        this.configuration.apiKey("Authorization"); // bearerAuth authentication
    }

    const response = await this.request({
      path: `/builds/{id}/traceability`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(requestParameters.id))
      ),
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    });

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      BuildTraceabilityFromJSON(jsonValue)
    );
  }

  /**
   * Aggregated traceability for a build (TCV-6726): execution results summed across every test plan linked to the build, per-plan result distribution, build-scoped risk coverage (risks exercised by test cases executed against the build), and the defects raised against those plans. Powers the Build detail traceability view. The response is provider-neutral — the client chooses the manual vs. Azure DevOps presentation from project settings.
   * Build traceability
   */
  async getBuildTraceability(
    requestParameters: GetBuildTraceabilityRequest
  ): Promise<BuildTraceability> {
    const response = await this.getBuildTraceabilityRaw(requestParameters);
    return await response.value();
  }

  /**
   * Get builds for a specific project
   * Get builds
   */
  async getBuildsRaw(
    requestParameters: GetBuildsRequest
  ): Promise<runtime.ApiResponse<Array<Build>>> {
    if (
      requestParameters.project === null ||
      requestParameters.project === undefined
    ) {
      throw new runtime.RequiredError(
        "project",
        "Required parameter requestParameters.project was null or undefined when calling getBuilds."
      );
    }

    const queryParameters: runtime.HTTPQuery = {};

    if (requestParameters.project !== undefined) {
      queryParameters["project"] = requestParameters.project;
    }

    if (requestParameters.environment !== undefined) {
      queryParameters["environment"] = requestParameters.environment;
    }

    if (requestParameters.versionContains !== undefined) {
      queryParameters["version_contains"] = requestParameters.versionContains;
    }

    if (requestParameters.limit !== undefined) {
      queryParameters["_limit"] = requestParameters.limit;
    }

    if (requestParameters.start !== undefined) {
      queryParameters["_start"] = requestParameters.start;
    }

    if (requestParameters.sort !== undefined) {
      queryParameters["_sort"] = requestParameters.sort;
    }

    if (requestParameters.filter !== undefined) {
      queryParameters["_filter"] = requestParameters.filter;
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] =
        this.configuration.apiKey("Authorization"); // bearerAuth authentication
    }

    const response = await this.request({
      path: `/builds`,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    });

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      jsonValue.map(BuildFromJSON)
    );
  }

  /**
   * Get builds for a specific project
   * Get builds
   */
  async getBuilds(requestParameters: GetBuildsRequest): Promise<Array<Build>> {
    const response = await this.getBuildsRaw(requestParameters);
    return await response.value();
  }
}
